import {
  CATEGORIES_FOR_HOMEPAGE,
  CATEGORIES_FOR_HOMEPAGE_CROSS_FILTER,
  CATEGORY_BY_ALIAS_MAP,
  CATEGORY_BY_ID,
  CATEGORY_BY_NAME_MAP,
  DISPLAYABLE_CATEGORIES,
  GET_CROSS_FILTER_DATA,
} from '@/store/getterTypes';
import {URL_QUERIES} from '@/const';

export default {
  [CATEGORY_BY_ALIAS_MAP](state) {
    return Object.fromEntries(
        Object.values(state.eventCategoriesById || {})
            ?.map((i) => [i.alias.toLowerCase(), i]),
    );
  },
  [CATEGORY_BY_NAME_MAP](state) {
    return Object.fromEntries(
        Object.values(state.eventCategoriesById || {})
            ?.map((i) => [i.name.toLowerCase(), i]),
    );
  },
  [CATEGORY_BY_ID](state) {
    return state.eventCategoriesById || {};
  },
  [DISPLAYABLE_CATEGORIES](state) {
    const arr = [];
    const cb = (category, displayableArr) => {
      if (category.is_displayable) {
        const arr = [];
        category.children?.forEach((cat) => cb(cat, arr));
        displayableArr.push({
          ...category,
          children: arr,
        });
      } else {
        category.children?.forEach((cat) => cb(cat, displayableArr));
      }
    };
    state.eventCategories?.forEach((category) => cb(category, arr));
    return arr;
  },
  [CATEGORIES_FOR_HOMEPAGE_CROSS_FILTER](state, getters) {
    const list = getters[GET_CROSS_FILTER_DATA]?.event_categories || [];
    const listWithParents = [...new Set([...list].reduce((arr, id) => {
      const category = state.eventCategoriesById[id];
      arr.push(id);
      if (category.parentArray?.length) {
        arr.push(...category.parentArray);
      }
      return arr;
    }, []))];

    return listWithParents.map((id) => {
      const category = state.eventCategoriesById[id];
      if (!category || !category.is_displayable) return null;
      const url = new URL(window.location.origin);
      url.searchParams.set(URL_QUERIES.category, category.alias.toLowerCase());
      return {
        id: category.id,
        name: category.name,
        url: url.href.replace(url.origin, ''),
        icon: category.image,
        weight: category.weight,
      };
    }).filter(Boolean).sort((a, b) => b.weight - a.weight);
  },
  [CATEGORIES_FOR_HOMEPAGE](state) {
    return [...Object.values(state.eventCategoriesById)].map((category) => {
      if (!category.is_displayable) return null;
      const url = new URL(window.location.origin);
      url.searchParams.set(URL_QUERIES.category, category.alias.toLowerCase());

      return {
        id: category.id,
        name: category.name,
        url: url.href.replace(url.origin, ''),
        icon: category.image,
        weight: category.weight,
      };
    }).filter(Boolean).sort((a, b) => b.weight - a.weight);
  },
};
